export default (axios, data) => axios.post('/payout', data);
